// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_qb-8";
export var editMode = "_qb-3";
export var headerRow = "_qb-a";
export var headerTitle = "_qb-b";
export var product = "_qb-1";
export var productDetails = "_qb-5";
export var productDivider = "_qb-7";
export var productImage = "_qb-2";
export var productInfo = "_qb-4";
export var productTitle = "_qb-6";
export var strikethrough = "_qb-9";
export var upsellProductsCard = "_qb-0";